import React, { useEffect, useState, useRef, version, Component } from "react";
import axios from "axios";
import Modal from "react-modal";
import { apiUrl, accountsApi } from "../../config/config";
import { Toaster, toast } from "react-hot-toast";
import TopNav from "../common/TopNav";
import SideBar from "../common/SideBar";
import DeviceHistoryModal from "./DeviceHistoryModal";
import * as XLSX from "xlsx";
import "./devicedeatils.css";
import { get } from "jquery";

Modal.setAppElement("#root");
const DeviceDetails = () => {
  const [devices, setDevices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  // Device clicked in the SERIAL NO column — opens the shared history popup
  // listing the patients this device has previously been connected to.
  const [historyDevice, setHistoryDevice] = useState(null);
  const [customernames, setCustomernames] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 20;

  // ── Per-device comments (shared with /battery-issue via Deviceinfo.comments) ──
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [commentsDevice, setCommentsDevice] = useState(null);
  const [commentsText, setCommentsText] = useState("");
  const [newComment, setNewComment] = useState("");
  const [loadingComments, setLoadingComments] = useState(false);
  const [savingComments, setSavingComments] = useState(false);

  const openComments = async (device) => {
    setCommentsDevice(device);
    setShowCommentsModal(true);
    setCommentsText("");
    setNewComment("");
    const macId = device.mac_id || device.Mac_id || "";
    if (!macId) {
      toast.error("MAC ID missing");
      return;
    }
    setLoadingComments(true);
    try {
      const res = await axios.get(`${apiUrl}api/users/getDeviceComments`, {
        params: { mac_id: macId },
      });
      setCommentsText(res.data?.comments || "");
    } catch (err) {
      console.error("loadDeviceComments failed", err);
      toast.error("Could not load comments");
    } finally {
      setLoadingComments(false);
    }
  };

  // ── "Find by Patient Device ID" lookup ──
  // Searches subscribe_logs for the given device_id and filters the table by the
  // returned mac_ids. Empty/cleared = show all devices.
  const [patientIdQuery, setPatientIdQuery] = useState("");
  const [patientIdLoading, setPatientIdLoading] = useState(false);
  const [matchedMacs, setMatchedMacs] = useState(null);   // null = no filter active
  const [patientIdInfo, setPatientIdInfo] = useState(""); // status message under input

  const findByPatientDeviceId = async () => {
    const id = patientIdQuery.trim();
    if (!id) { toast.error("Enter a patient device ID"); return; }
    setPatientIdLoading(true);
    setPatientIdInfo("");
    try {
      const res = await axios.get(`${apiUrl}api/users/findMacsByDeviceId`, {
        params: { device_id: id },
      });
      const macs = Array.isArray(res.data?.macs) ? res.data.macs : [];
      if (macs.length === 0) {
        toast(`No devices linked to patient ${id}`, { icon: "ℹ️" });
        setMatchedMacs([]);                                    // empty filter → empty table
        setPatientIdInfo(`No subscribe_log entries for ${id}`);
      } else {
        setMatchedMacs(macs);
        setPatientIdInfo(`${macs.length} device${macs.length > 1 ? "s" : ""} linked to ${id}`);
        toast.success(`${macs.length} device(s) found`);
      }
      setCurrentPage(1);
    } catch (err) {
      console.error("findMacsByDeviceId failed", err);
      const msg = err.response?.data?.message || err.message || "lookup failed";
      toast.error("Lookup failed: " + msg);
      setPatientIdInfo("Lookup failed");
    } finally {
      setPatientIdLoading(false);
    }
  };

  const clearPatientIdSearch = () => {
    setPatientIdQuery("");
    setMatchedMacs(null);
    setPatientIdInfo("");
    setCurrentPage(1);
  };

  const saveComment = async () => {
    const macId = (commentsDevice && (commentsDevice.mac_id || commentsDevice.Mac_id)) || "";
    if (!macId) { toast.error("MAC ID missing"); return; }
    const newText = (newComment || "").trim();
    if (!newText) return;
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true,
    });
    const entry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (commentsText || "").trim();
    const comments = existing ? `${existing}\n${entry}` : entry;
    try {
      setSavingComments(true);
      await axios.post(`${apiUrl}api/users/saveDeviceComments`, {
        mac_id: macId,
        comments,
      });
      setCommentsText(comments);
      setNewComment("");
      setDevices((prev) =>
        prev.map((d) =>
          (d.mac_id || d.Mac_id) === macId ? { ...d, comments } : d
        )
      );
      toast.success("Comment added");
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      console.error("saveDeviceComments failed", err);
      toast.error("Save failed: " + msg);
    } finally {
      setSavingComments(false);
    }
  };
     const menus = [
       { title: "Verifier Home", url: "/verifier-home" },
       { title: "Patient list", url: "/patient-list" },
       { title: "Labled Patients", url: "/labled-patients" },
       { title: "Verified", url: "/verification-completed" },
 
     ];
     if (localStorage.getItem("verifiertype") === "8") {
       menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
     }
     if (localStorage.getItem("AdminUser") === "8") {
       menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
       menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
     }
 
     if (localStorage.getItem("verifiertype") === "8") {
       menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
     }
     if (localStorage.getItem("verifiertype") === "8") {
       menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
     }
     if (localStorage.getItem("AdminUser") === "8") {
       menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
     }
     if (localStorage.getItem("AdminUser") === "8") {
       menus.splice(6, 0, {
         title: "Supported Person",
         url: "/supported-persons",
       });

       }
        if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, {
           title: "Reset Password",
           url: "/ResetPassword",
         });
     }
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [newDevice, setNewDevice] = useState({
    serial_no: "",
    mac_id: "",
    whatsapp: "",
    mail: "",
    customer_details: "",
    contactPerson: "",
    VerisonDetails: "",
  });
  const [customerNames, setCustomerNames] = useState([]);
  const [customerSearch, setCustomerSearch] = useState("");
  const [SelectedCustomerID, setSelectedCustomerID] = useState("");
  // Same fields as Users by role (all mandatory); signing handle + linked DB ID
  // only for doctors. Gender defaults to Male - it used to start empty with no
  // field on the form, so "+ Customer" always failed with "All fields are required".
  const emptyNewCustomer = () => ({
    name: "",
    phone: "",
    email: "",
    password: "",
    address: "",
    gender: "M",
    type: "customer",
    customerName: "",
    accountCategory: "partner",
    contactPerson: "",
    whatsappNumber: "",
    mailContact: "",
    signatureDoctorId: "",
    database_id: "",
  });
  const [newCustomer, setNewCustomer] = useState(emptyNewCustomer);

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const response = await axios.get(`${apiUrl}api/users/GetDevicedetails`);
      // Map customer_id to customerId for easier handling in UI
      const devicesWithCustomerId = response.data.reverse().map((device) => ({
        ...device,
        customerId: device.customer_id || device.customerId || "",
      }));
      setDevices(devicesWithCustomerId);
    } catch (error) {
      console.error("Error fetching device details", error);
    }
  };

  const filterRows = () => {
    let rows = devices;

    // Patient-Device-ID filter — restrict to mac_ids returned by /findMacsByDeviceId
    if (Array.isArray(matchedMacs)) {
      const wanted = new Set(matchedMacs.map((m) => (m || "").toUpperCase()));
      rows = rows.filter((d) => {
        const m = (d.mac_id || d.Mac_id || "").toUpperCase();
        return wanted.has(m);
      });
    }

    // Free-text search filter
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      rows = rows.filter((device) =>
        Object.values(device).some(
          (value) => value && value.toString().toLowerCase().includes(q)
        )
      );
    }

    return rows;
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(filterRows().length / rowsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleEditClick = (device) => {
    setSelectedDevice(device);
  };
  const handleDeleteClick = async (device) => {
    const mac_id = device.mac_id;

    if (!window.confirm("Do you want to delete this device?")) {
      return; // Stop execution if user cancels
    }

    try {
      console.log("Deleting device with MAC ID:", mac_id);

      const response = await axios.delete(
        `${apiUrl}api/users/DeleteDeviceInfo`,
        {
          params: { mac_id },
        }
      );

      if (response.status === 200) {
        toast.success("Device deleted successfully!");
        // Optionally refresh the device list after deletion
        fetchDevices();
      } else {
        toast.error("Failed to delete device!");
      }
    } catch (err) {
      console.error("Error deleting device:", err);
      toast.error("Error deleting device!");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedDevice((prevDevice) => ({
      ...prevDevice,
      [name]: value,
    }));
  };

  const handleNewDeviceChange = (e) => {
    const { name, value } = e.target;
    setNewDevice((prevDevice) => ({
      ...prevDevice,
      [name]: value,
    }));
  };

  // MAC must be AA:BB:CC:DD:EE:FF (the app matches patients to devices by it);
  // serials look like BCZ26317021. Catches empty / swapped entries before saving.
  const MAC_RE = /^[0-9A-F]{2}(:[0-9A-F]{2}){5}$/;
  const SERIAL_RE = /^BCZ[0-9A-Z]{6,12}$/;
  const normMac = (v) => String(v || "").trim().toUpperCase().replace(/-/g, ":");
  const normSerial = (v) => String(v || "").trim().toUpperCase();

  const handleAddDevice = async () => {
    let mac = normMac(newDevice.mac_id);
    let serial = normSerial(newDevice.serial_no);
    if (!mac || !serial) {
      toast.error("Enter both MAC ID and Serial No");
      return;
    }
    if (MAC_RE.test(serial) && !MAC_RE.test(mac)) {
      if (!window.confirm(`MAC ID and Serial No look swapped:\n\nMAC ID: ${mac}\nSerial No: ${serial}\n\nSwap them and save?`)) return;
      [mac, serial] = [serial, mac];
    }
    if (!MAC_RE.test(mac)) {
      toast.error("MAC ID must look like AA:BB:CC:DD:EE:FF");
      return;
    }
    if (!SERIAL_RE.test(serial) &&
        !window.confirm(`Serial No "${serial}" does not look like a device serial (e.g. BCZ26317021).\n\nSave anyway?`)) return;
    try {
      // Only pass customer_id in the API body
      const { customerName, ...rest } = newDevice;
      const payload = {
        ...rest,
        mac_id: mac,
        serial_no: serial,
        created_by: localStorage.getItem("verifiername") || "",
      };

      // Always added through web (main server): duplicate check on all servers and
      // the same device created on web, web1, web2, web4, web5 and web6.
      const res = await axios.post(`${accountsApi}api/users/addDeviceAll`, payload);
      const r = (res.data && res.data.data) || {};
      const notCopied = Object.entries(r.servers || {})
        .filter(([, v]) => !String(v).startsWith("created"))
        .map(([k]) => k);
      fetchDevices();
      setNewDevice({
        VerisonDetails: "",
        serial_no: "",
        mac_id: "",
        whatsapp: "",
        mail: "",
        customer_details: "",
        contactPerson: "",
      });
      try { if (window.$) window.$("#addDeviceModal").modal("hide"); } catch (e) {}
      toast.success(
        `Device ${r.serial_no || serial} added` +
          (notCopied.length ? " - not copied to: " + notCopied.join(", ") : " on all servers"),
        { duration: 8000 }
      );
    } catch (error) {
      console.error("Error adding device", error);
      const body = error.response && error.response.data;
      toast.error("Error adding device" + (body && body.error ? ": " + body.error : ""));
    }
  };

  const handleNewCustomerChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCustomer = async () => {
    try {
      // Validate required fields
      const labels = {
        type: "Type", name: "Name", customerName: "Customer name", phone: "Phone",
        email: "Email", password: "Password", address: "Address", gender: "Gender",
        accountCategory: "Account category", contactPerson: "Account coordinator",
        whatsappNumber: "WhatsApp number", mailContact: "Contact email",
        signatureDoctorId: "Signing handle", database_id: "Linked DB ID",
      };
      const required = ["type", "name", "customerName", "phone", "email", "password", "address",
        "gender", "contactPerson", "whatsappNumber", "mailContact"];
      if (newCustomer.type === "customer") required.push("accountCategory");
      if (newCustomer.type === "doctor") required.push("signatureDoctorId", "database_id");
      const missing = required.filter((k) => !String(newCustomer[k] || "").trim());
      if (missing.length) {
        toast.error("Please fill: " + missing.map((k) => labels[k]).join(", "));
        return;
      }
      if (!/^\d{10}$/.test(String(newCustomer.phone).trim()) || !/^\d{10}$/.test(String(newCustomer.whatsappNumber).trim())) {
        toast.error("Phone and WhatsApp number must be 10 digits");
        return;
      }
      if (String(newCustomer.password).length < 6) {
        toast.error("Password must be at least 6 characters");
        return;
      }

      // Prepare customer data for AddCustomer API
      const customerData = {
        name: newCustomer.name,
        phone: newCustomer.phone,
        email: newCustomer.email,
        password: newCustomer.password,
        address: newCustomer.address,
        gender: newCustomer.gender,
        type: newCustomer.type,
        customerName: newCustomer.customerName,
        contactPerson: newCustomer.contactPerson,
        whatsappNumber: newCustomer.whatsappNumber,
        mailContact: newCustomer.mailContact,
      };
      if (newCustomer.type === "customer") customerData.accountCategory = newCustomer.accountCategory;
      if (newCustomer.type === "doctor") {
        customerData.signatureDoctorId = newCustomer.signatureDoctorId;
        customerData.database_id = newCustomer.database_id;
      }

      console.log("Sending customer data to AddCustomer:", customerData);
      // Created on web + all servers (hashed password, WCN code, duplicate check)
      customerData.created_by = localStorage.getItem("verifiername") || "";
      const response = await axios.post(`${accountsApi}api/users/createCustomerAll`, customerData);
      const r = (response.data && response.data.data) || {};
      console.log("Customer added response:", response.data);

      // clear the form
      setNewCustomer(emptyNewCustomer());
      toast.success("Customer added" + (r.customerId ? " with code " + r.customerId : "") + " on all servers", { duration: 8000 });
      // close the window only after a successful save (it used to close on
      // every click, hiding the "Please fill" message)
      try { if (window.$) window.$("#addCustomerModal").modal("hide"); } catch (e) {}
    } catch (error) {
      console.error("Error adding customer:", error);
      if (error.response && error.response.data) {
        console.error("Error response:", error.response.data);
      }
      
      let errorMessage = "Failed to add customer";
      if (error.response && error.response.data) {
        // Check for validation errors object
        const responseData = error.response.data;
        if (responseData.name || responseData.email || responseData.phone || responseData.password || responseData.gender) {
          errorMessage = responseData.name || responseData.email || responseData.phone || responseData.password || responseData.gender;
        } else if (responseData.message) {
          errorMessage = responseData.message;
        } else if (responseData.error) {
          errorMessage = responseData.error;
        } else if (responseData.exists) {
          errorMessage = responseData.exists;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
    }
  };

  const handleEditDevice = async () => {
    const serial = normSerial(selectedDevice.serial_no);
    if (serial && MAC_RE.test(normMac(serial))) {
      toast.error("Serial No looks like a MAC address - enter the BCZ serial");
      return;
    }
    if (serial && !SERIAL_RE.test(serial) &&
        !window.confirm(`Serial No "${serial}" does not look like a device serial (e.g. BCZ26317021).\n\nSave anyway?`)) return;
    try {
      // Pass customer_id in the update payload
      const { customerName, ...rest } = selectedDevice;
      const payload = {
        ...rest,
        serial_no: serial,
        customer_id: selectedDevice.customerId,
      };
      await axios.post(`${apiUrl}api/users/UpdateDeviceInfo`, payload);
      fetchDevices();
      try { if (window.$) window.$("#editDeviceModal").modal("hide"); } catch (e) {}
      toast.success("Device updated successfully");
    } catch (error) {
      console.error("Error updating device", error);
      const body = error.response && error.response.data;
      toast.error("Error updating device" + (body && body.error ? ": " + body.error : ""));
    }
  };

  // ────────────────────────────────────────────────────────────────
  // Excel Import / Export
  // ────────────────────────────────────────────────────────────────
  // Match key for import: `mac_id` (unique device identifier).
  // Rows whose mac_id doesn't exist in the current device list are
  // skipped — never created. Summary toast shows updated + skipped.
  // ────────────────────────────────────────────────────────────────
  const fileInputRef = useRef(null);
  const [importBusy, setImportBusy] = useState(false);

  // Fields exported / accepted on import. Names mirror what the backend
  // stores. `_id` is the ONLY truly immutable field — it's the Mongo
  // primary key used to look up the existing record. Everything else
  // (including `mac_id` and `customerName`) can be edited:
  //   • mac_id    → just renamed on the device
  //   • customerName → resolved back to a customer_id via the
  //     customerNames lookup, then customer_id is updated (keeps data
  //     normalized — the device still links to a User type 7 by ID).
  const DEVICE_EXPORT_FIELDS = [
    "_id",              // Mongo ObjectId — match key, read-only
    "mac_id",           // device MAC — editable
    "serial_no",
    "batch_no",
    "pck_date",
    "sales_date",
    "customer_id",      // FK to User (type 7) — the canonical link
    "customerName",     // display name — editable; resolves to customer_id
    "customer_details", // free-text clinic notes (separate from customerName)
    "contactPerson",
    "mail",
    "whatsapp",
    "status",
    "priority",
    "VersionDetails",
  ];
  // Only the Mongo _id is treated as untouchable. Every other field can
  // be edited via Excel.
  const DEVICE_IMMUTABLE_FIELDS = ["_id"];

  const handleExportDevices = async () => {
    try {
      const rows = filterRows();           // current filtered/visible devices
      if (!rows.length) {
        toast.error("No devices to export");
        return;
      }

      // customerNames is normally populated by the Add Device modal. If
      // the admin hasn't opened it this session, the state is still []
      // and every exported customerName would be blank. Fetch on demand
      // here so Export works as a first action.
      let resolvedCustomers = customerNames;
      if (!resolvedCustomers || resolvedCustomers.length === 0) {
        try {
          const res = await axios.get(`${apiUrl}api/users/getCustomerNames`);
          let data = res.data;
          if (!Array.isArray(data)) {
            if (data && Array.isArray(data.data))   data = data.data;
            else if (data && Array.isArray(data.result)) data = data.result;
            else data = [];
          }
          resolvedCustomers = data
            .filter((it) => it && (it.customerId || it.customer_id || it._id))
            .map((it) => ({
              id:   it.customerId || it.customer_id || it._id,
              name: it.name || it.customer_details || it.customer_name || "",
            }));
          // Cache for subsequent exports / the table render.
          setCustomerNames(resolvedCustomers);
        } catch (e) {
          console.warn("[Device-details] export customer lookup failed:", e.message);
          resolvedCustomers = [];
        }
      }

      // Build a quick customerId → customer name map so each row can
      // include the human-readable customer name without a per-row lookup.
      // Falls back to "" when the customer isn't in the loaded list (e.g.
      // device assigned to a customer the current admin can't see).
      const nameById = {};
      (resolvedCustomers || []).forEach((c) => {
        if (c && c.id) nameById[String(c.id)] = c.name || "";
      });

      const data = rows.map((d) => {
        const row = {};
        const cid = d.customer_id || d.customerId || "";
        DEVICE_EXPORT_FIELDS.forEach((k) => {
          if (k === "customer_id")   row[k] = cid;
          else if (k === "customerName") row[k] = nameById[String(cid)] || "";
          else if (k === "_id")      row[k] = d._id ? String(d._id) : "";
          else                       row[k] = d[k] != null ? d[k] : "";
        });
        return row;
      });
      const ws = XLSX.utils.json_to_sheet(data, { header: DEVICE_EXPORT_FIELDS });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Devices");
      const stamp = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `devices_${stamp}.xlsx`);
      toast.success(`Exported ${rows.length} devices`);
    } catch (err) {
      console.error("[Device-details] export failed:", err);
      toast.error("Export failed: " + err.message);
    }
  };

  const handleImportClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleImportFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";                   // allow re-selecting same file
    if (!file) return;

    setImportBusy(true);
    try {
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: "array" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      if (!rows.length) {
        toast.error("Imported file is empty");
        setImportBusy(false);
        return;
      }

      // Ensure customer list is loaded so we can resolve customerName →
      // customer_id during the merge. Same self-fetch as the export
      // handler — only runs if state is still empty. Use a local var
      // because setState is async and the for-loop below needs the
      // resolved list immediately.
      let customerLookupList = customerNames || [];
      if (customerLookupList.length === 0) {
        try {
          const res = await axios.get(`${apiUrl}api/users/getCustomerNames`);
          let data = res.data;
          if (!Array.isArray(data)) {
            if (data && Array.isArray(data.data))   data = data.data;
            else if (data && Array.isArray(data.result)) data = data.result;
            else data = [];
          }
          customerLookupList = data
            .filter((it) => it && (it.customerId || it.customer_id || it._id))
            .map((it) => ({
              id:   it.customerId || it.customer_id || it._id,
              name: it.name || it.customer_details || it.customer_name || "",
            }));
          setCustomerNames(customerLookupList);   // cache for future renders
        } catch (e) {
          console.warn("[Device-details] import customer lookup failed:", e.message);
        }
      }

      // Build two lookup maps:
      //   byId  → primary match key (Mongo _id, immutable)
      //   byMac → fallback if the row has no _id but a known mac_id
      const byId  = {};
      const byMac = {};
      devices.forEach((d) => {
        if (d._id)    byId[String(d._id).trim()]   = d;
        if (d.mac_id) byMac[String(d.mac_id).trim()] = d;
      });

      // customerName → customer_id resolver. Used when the import row
      // has a customerName but the customer_id is blank or stale, so
      // editing customerName in Excel actually re-points the device.
      const customerIdByName = {};
      customerLookupList.forEach((c) => {
        if (c && c.name) customerIdByName[String(c.name).trim().toLowerCase()] = c.id;
      });

      let updated = 0;
      const skippedRows = [];   // log of {_id, mac_id} for diagnostic output
      const errors = [];

      // Sequential per row — keeps backend load predictable and toast
      // counts accurate. Switch to Promise.all if you need speed.
      for (const r of rows) {
        // Match by _id first (authoritative), fall back to mac_id.
        const rowId  = r._id    ? String(r._id).trim()    : "";
        const rowMac = r.mac_id ? String(r.mac_id).trim() : "";
        const existing = (rowId && byId[rowId]) || (rowMac && byMac[rowMac]) || null;
        if (!existing) {
          skippedRows.push({ _id: rowId || "(blank)", mac_id: rowMac || "(blank)" });
          continue;
        }

        // Build merged from ONLY the export-fields whitelist.
        // NEVER spread `existing` — it carries server-managed fields
        // (__v, createdAt, updatedAt, possibly nested refs) that strict
        // Mongoose validators reject. Excel value wins if non-empty,
        // else fall back to existing so untouched fields stay intact.
        const merged = {};
        DEVICE_EXPORT_FIELDS.forEach((k) => {
          if (DEVICE_IMMUTABLE_FIELDS.indexOf(k) !== -1) return;     // protect _id only
          if (r[k] !== "" && r[k] != null) {
            merged[k] = r[k];
          } else if (existing[k] !== undefined && existing[k] !== null) {
            merged[k] = existing[k];
          }
        });

        // If the import row edited customerName, resolve it to a real
        // customer_id via the lookup. Falls back to whatever customer_id
        // was already in the row / existing record if no match found.
        let resolvedCustomerId = merged.customer_id || merged.customerId || existing.customer_id || "";
        if (r.customerName && r.customerName !== "") {
          const key = String(r.customerName).trim().toLowerCase();
          if (customerIdByName[key]) {
            resolvedCustomerId = customerIdByName[key];
          }
        }

        const { customerName, customerId, ...payload } = merged;
        payload.customer_id = resolvedCustomerId;
        // _id is always re-asserted from the existing record — never
        // taken from the import file, never modifiable.
        payload._id = existing._id;
        try {
          await axios.post(`${apiUrl}api/users/UpdateDeviceInfo`, payload);
          updated++;
        } catch (err) {
          const status = err.response && err.response.status;
          const body   = err.response && err.response.data;
          const reason =
            (body && typeof body === "string" && body) ||
            (body && body.error) ||
            (body && body.message) ||
            (body && JSON.stringify(body).slice(0, 200)) ||
            err.message;
          errors.push({
            _id:    existing._id,
            mac_id: existing.mac_id,
            status,
            reason,
            payload,
          });
        }
      }

      fetchDevices();
      const parts = [`${updated} updated`];
      if (skippedRows.length) parts.push(`${skippedRows.length} skipped (no match)`);
      if (errors.length)      parts.push(`${errors.length} failed`);
      toast.success(parts.join(", ") + (skippedRows.length || errors.length ? " — see console (F12)" : ""));
      if (skippedRows.length) {
        console.warn(`[Device-details] ${skippedRows.length} rows skipped (no matching _id/mac_id in current devices):`, skippedRows);
      }
      if (errors.length) {
        console.warn(`[Device-details] ${errors.length} rows failed to update:`, errors);
      }
    } catch (err) {
      console.error("[Device-details] import failed:", err);
      toast.error("Import failed: " + err.message);
    } finally {
      setImportBusy(false);
    }
  };

  const handleAddDeviceModalOpen = async () => {
    try {
      const response = await axios.get(`${apiUrl}api/users/getCustomerNames`);
      let data = response.data;
      // Normalize: expect array of objects with id and name
      if (!Array.isArray(data)) {
        if (data && Array.isArray(data.data)) {
          data = data.data;
        } else if (data && Array.isArray(data.result)) {
          data = data.result;
        } else {
          data = [];
        }
      }
      // Normalize to { id, name, contactPerson, whatsapp, mail, phone, email }.
      // `getCustomerNames` now returns users (type 7) enriched with
      // device_infos contact fields, keyed by the new `customerId`
      // (WCN###). Legacy aliases `customer_id` / `customer_details` /
      // `_id` are kept as fallbacks so older responses still parse.
      data = data
        .filter((item) => item && (item.customerId || item.customer_id || item._id))
        .map((item) => ({
          id:            item.customerId || item.customer_id || item._id,
          // Mongo _id kept so devices that link by ObjectId (instead of
          // the WCN code) still resolve to the same customer.
          mongoId:       item._id ? String(item._id) : "",
          name:          item.name || item.customer_details || item.customer_name || "",
          contactPerson: item.contactPerson || "",
          whatsapp:      item.whatsapp      || "",
          mail:          item.mail          || "",
          phone:         item.phone         || "",
          email:         item.email         || "",
        }));
      setCustomerNames(data);
      setCustomerSearch("");
    } catch (error) {
      setCustomerNames([]);
      setCustomerSearch("");
    }
  };

  const handleCustomerSelect = (e) => {
    const selectedId = e.target.value;
    const selected = customerNames.find((c) => c.id === selectedId);
    // Auto-fill device-side contact fields from the customer record so
    // a new device picks up the customer's primary contact by default.
    setNewDevice((prev) => ({
      ...prev,
      customerId:       selectedId,
      customerName:     selected ? selected.name : "",
      customer_details: selected ? selected.name : prev.customer_details,
      contactPerson:    (selected && selected.contactPerson) || prev.contactPerson,
      whatsapp:         (selected && selected.whatsapp)      || prev.whatsapp,
      mail:             (selected && selected.mail)          || prev.mail,
    }));
    setSelectedCustomerID(selectedId);
  };

  const totalPages = Math.ceil(filterRows().length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const displayedRows = filterRows().slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const paginationNumbers = [];
  const startPage = Math.max(1, currentPage - 4);
  const endPage = Math.min(totalPages, startPage + 7);

  for (let i = startPage; i <= endPage; i++) {
    paginationNumbers.push(i);
  }

  // shared cell style
  const thStyle = {
    padding: "8px 10px", textAlign: "center", color: "#89a8c0",
    fontWeight: 600, fontSize: "11px", textTransform: "uppercase",
    letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none",
    whiteSpace: "nowrap", background: "#031213",
  };
  const tdStyle = {
    verticalAlign: "middle", textAlign: "center",
    fontSize: "12px", padding: "8px 10px", whiteSpace: "nowrap",
  };

  return (
    <div className="wrapper theme-6-active box-layout pimary-color-green">
      <DeviceHistoryModal
        open={!!historyDevice}
        macId={historyDevice && historyDevice.mac_id}
        serial={historyDevice && historyDevice.serial_no}
        theme="dark"
        onClose={() => setHistoryDevice(null)}
      />
      <Toaster position="top-right" reverseOrder={false} />
      {/* TopNav removed — profile & logout in SideBar */}
      <SideBar menus={menus} profileLink="verifier-profile" />
      <div className="right-sidebar-backdrop"></div>
      <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh", width: "100%", padding: 0 }}>
        <div className="container-fluid" style={{ padding: 0, margin: 0, width: "100%" }}>
          <div className="panel panel-default card-view" style={{ background: "#072224", borderRadius: 0, margin: 0, minHeight: "100vh", boxShadow: "0 2px 8px rgba(0,0,0,0.25)" }}>

            {/* ── Panel Header — title row + controls row (always visible) ── */}
            <div style={{ background: "#0c2e32", borderBottom: "2px solid #1e6b72" }}>
              {/* Single combined toolbar — title left, then all controls flow naturally
                  with wrap. No space-between (prevents far-right clipping). */}
              <div style={{
                padding: "10px 14px",
                display: "flex", alignItems: "center", gap: 10,
                flexWrap: "wrap",
                boxSizing: "border-box",
                maxWidth: "100%",
                overflow: "hidden",
              }}>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: "14px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  📡 Device Details
                  {devices.length > 0 && (
                    <span style={{ marginLeft: 8, fontSize: "11px", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa", fontWeight: 600 }}>
                      {devices.length} devices
                    </span>
                  )}
                </span>
                <button
                  data-toggle="modal" data-target="#addCustomerModal"
                  style={{ display: "inline-flex", alignItems: "center", gap: 5, height: 32, padding: "0 12px", fontSize: "12px", background: "#1a4a2e", border: "1px solid #2ecd99", borderRadius: 6, color: "#2ecd99", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}
                >➕ Customer</button>
                <button
                  data-toggle="modal" data-target="#addDeviceModal"
                  onClick={handleAddDeviceModalOpen}
                  style={{ display: "inline-flex", alignItems: "center", gap: 5, height: 32, padding: "0 12px", fontSize: "12px", background: "#1a3a52", border: "1px solid #3a8abf", borderRadius: 6, color: "#6ac8f5", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}
                >➕ Device</button>

                {/* Excel Export — current filtered devices */}
                <button
                  type="button"
                  onClick={handleExportDevices}
                  title="Download current devices as Excel"
                  style={{ display: "inline-flex", alignItems: "center", gap: 5, height: 32, padding: "0 12px", fontSize: "12px", background: "#0e3a2e", border: "1px solid #2ecd99", borderRadius: 6, color: "#2ecd99", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}
                >⬇ Export</button>

                {/* Excel Import — updates by mac_id; never creates */}
                <button
                  type="button"
                  onClick={handleImportClick}
                  disabled={importBusy}
                  title="Upload Excel to bulk-update devices (matched by mac_id)"
                  style={{ display: "inline-flex", alignItems: "center", gap: 5, height: 32, padding: "0 12px", fontSize: "12px", background: importBusy ? "#3a3a3a" : "#3a2e0e", border: "1px solid #f39c12", borderRadius: 6, color: importBusy ? "#888" : "#f39c12", cursor: importBusy ? "not-allowed" : "pointer", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}
                >{importBusy ? "Importing…" : "⬆ Import"}</button>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx,.xls"
                  style={{ display: "none" }}
                  onChange={handleImportFile}
                />
              </div>

              {/* Search row — wraps cleanly on narrow widths */}
              <div style={{
                padding: "0 14px 10px",
                display: "flex", alignItems: "center", gap: 8,
                flexWrap: "wrap",
                boxSizing: "border-box",
                maxWidth: "100%",
                overflow: "hidden",
              }}>
                {/* Find by Patient Device ID — looks up subscribe_logs */}
                <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                  <span style={{ position: "absolute", left: 9, color: "#f39c12", fontSize: "13px", pointerEvents: "none" }}>👤</span>
                  <input
                    type="text"
                    placeholder="Patient ID…"
                    value={patientIdQuery}
                    onChange={(e) => setPatientIdQuery(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") findByPatientDeviceId(); }}
                    style={{ height: 32, paddingLeft: 28, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #f39c12", background: "#3a2a0e", color: "#fff", outline: "none", width: 160 }}
                  />
                  <button
                    onClick={findByPatientDeviceId}
                    disabled={patientIdLoading}
                    title="Search subscribe_logs"
                    style={{ height: 32, padding: "0 10px", fontSize: 12, fontWeight: 600, background: "#f39c12", border: "1px solid #f39c12", borderRadius: 6, color: "#1a1408", cursor: "pointer", whiteSpace: "nowrap" }}
                  >{patientIdLoading ? "…" : "Find"}</button>
                  {Array.isArray(matchedMacs) && (
                    <button
                      onClick={clearPatientIdSearch}
                      title="Clear patient-id filter"
                      style={{ height: 32, padding: "0 8px", fontSize: 14, background: "transparent", border: "1px solid #c0392b", borderRadius: 6, color: "#e74c3c", cursor: "pointer" }}
                    >×</button>
                  )}
                </div>

                {/* Existing free-text search */}
                <div style={{ position: "relative", display: "flex", alignItems: "center", flexShrink: 0 }}>
                  <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "13px", pointerEvents: "none" }}>🔍</span>
                  <input
                    type="text"
                    placeholder="Search device, MAC, customer…"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ height: 32, paddingLeft: 28, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#fff", outline: "none", width: 220 }}
                  />
                </div>
              </div>
            </div>

            <div className="panel-wrapper collapse in">
              {/* Filter banner — visible only when a patient-id lookup is active */}
              {Array.isArray(matchedMacs) && (
                <div style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "8px 14px", background: "#3a2a0e", borderBottom: "1px solid #f39c12",
                  color: "#fff", fontSize: 12,
                }}>
                  <span>
                    👤 Showing <strong style={{ color: "#f39c12" }}>{matchedMacs.length}</strong> device{matchedMacs.length !== 1 ? "s" : ""} linked to patient ID{" "}
                    <strong style={{ color: "#f39c12" }}>{patientIdQuery}</strong>
                    {patientIdInfo && <span style={{ marginLeft: 8, opacity: 0.7 }}>· {patientIdInfo}</span>}
                  </span>
                  <button
                    onClick={clearPatientIdSearch}
                    style={{ padding: "4px 10px", fontSize: 11, background: "transparent", border: "1px solid #f39c12", borderRadius: 5, color: "#f39c12", cursor: "pointer", fontWeight: 600 }}
                  >Clear filter</button>
                </div>
              )}
              <div className="panel-body" style={{ padding: 0 }}>
                <div className="table-responsive">
                  <table className="table table-striped" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                    <colgroup>
                      <col style={{ width: "4%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "16%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "7%" }} />
                      <col style={{ width: "12%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "11%" }} />
                      <col style={{ width: "8%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th style={thStyle}>SL</th>
                        <th style={thStyle}>Serial No</th>
                        <th style={thStyle}>🏢 Customer</th>
                        <th style={thStyle}>MAC ID</th>
                        <th style={thStyle}>Version</th>
                        <th style={thStyle}>📱 WhatsApp</th>
                        <th style={thStyle}>✉️ Mail</th>
                        <th style={thStyle}>👤 Account Coordinator</th>
                        <th style={thStyle}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedRows.map((device, index) => (
                        <tr key={device._id}>
                          <td style={tdStyle}>{startIndex + index + 1}</td>
                          <td style={{ ...tdStyle, fontFamily: "monospace", fontSize: "11px" }}>
                            {device.mac_id ? (
                              <button
                                type="button"
                                title="Previously connected patients"
                                onClick={() => setHistoryDevice(device)}
                                style={{ background: "none", border: "none", padding: 0, font: "inherit", color: "#2eaabb", textDecoration: "underline", cursor: "pointer" }}
                              >
                                {device.serial_no || "—"}
                              </button>
                            ) : (
                              device.serial_no || "—"
                            )}
                          </td>
                          <td style={{ ...tdStyle, textAlign: "left", whiteSpace: "normal" }}>
                            {(() => {
                              // Resolve the device's linked customer (customerId →
                              // customerNames[].name from /getCustomerNames). The
                              // free-text customer_details field stays as a sub-line
                              // for rows where it carries extra info (e.g. clinic
                              // location) different from the customer's name.
                              const linked = device.customerId
                                ? customerNames.find(
                                    (c) =>
                                      c.id === device.customerId ||
                                      (c.mongoId && c.mongoId === String(device.customerId))
                                  )
                                : null;
                              const resolvedName = linked && linked.name ? linked.name : "";
                              const detailText = device.customer_details || "";
                              const primary =
                                resolvedName || detailText || "—";
                              const secondary =
                                resolvedName &&
                                detailText &&
                                detailText.trim() !== resolvedName.trim()
                                  ? detailText
                                  : "";
                              // Customer ID (WCN###) — surfaced as a small
                              // mono badge so it can be scanned at a glance
                              // and also picks up Ctrl-F searches.
                              const customerIdLabel = device.customerId
                                || device.customer_id
                                || "";
                              return (
                                <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.3 }}>
                                  <span style={{ fontWeight: 600, color: "#dbe7ef" }}>
                                    {primary}
                                  </span>
                                  {customerIdLabel && (
                                    <span
                                      title="Customer ID"
                                      style={{
                                        marginTop: 3,
                                        alignSelf: "flex-start",
                                        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                                        fontSize: "10.5px",
                                        fontWeight: 700,
                                        letterSpacing: "0.3px",
                                        color: "#5ac8fa",
                                        background: "rgba(90,200,250,0.10)",
                                        border: "1px solid rgba(90,200,250,0.30)",
                                        borderRadius: 4,
                                        padding: "1px 6px",
                                      }}
                                    >
                                      {customerIdLabel}
                                    </span>
                                  )}
                                  {secondary && (
                                    <span style={{ fontSize: "10px", color: "#7a93a4", marginTop: 2 }}>
                                      {secondary}
                                    </span>
                                  )}
                                </div>
                              );
                            })()}
                          </td>
                          <td style={{ ...tdStyle, fontSize: "11px" }}>
                            <MacIdModal device={device} />
                          </td>
                          <td style={tdStyle}>
                            <span style={{ background: "rgba(90,200,250,0.12)", color: "#5ac8fa", border: "1px solid rgba(90,200,250,0.3)", borderRadius: 6, padding: "2px 7px", fontSize: "11px", fontWeight: 600 }}>
                              {device.VerisonDetails || "—"}
                            </span>
                          </td>
                          <td style={tdStyle}>{device.whatsapp || "—"}</td>
                          <td style={{ ...tdStyle, textAlign: "left", fontSize: "11px", whiteSpace: "normal", wordBreak: "break-all" }}>
                            {device.mail
                              ? device.mail.split(",").map((email, i) => (
                                  <div key={i} style={{ lineHeight: 1.6 }}>{email.trim()}</div>
                                ))
                              : "—"}
                          </td>
                          <td style={tdStyle}>{device.contactPerson || "—"}</td>
                          <td style={{ ...tdStyle }}>
                            <div style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                              {/* ✏️ Edit */}
                              <button
                                title="Edit Device"
                                onClick={async () => {
                                  handleEditClick(device);
                                  await handleAddDeviceModalOpen();
                                }}
                                data-toggle="modal"
                                data-target="#editDeviceModal"
                                style={{ background: "none", border: "1px solid #3a8abf", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: "14px", color: "#6ac8f5" }}
                              >✏️</button>
                              {/* 💬 Comments — shared with /battery-issue */}
                              <button
                                title="Device Comments"
                                onClick={() => openComments(device)}
                                style={{ background: "none", border: "1px solid #e67e22", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: "14px", color: "#e67e22" }}
                              >💬</button>
                              {/* 🗑️ Delete */}
                              <button
                                title="Delete Device"
                                onClick={() => handleDeleteClick(device)}
                                style={{ background: "none", border: "1px solid #c0392b", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: "14px", color: "#e74c3c" }}
                              >🗑️</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 14px", gap: 2 }}>
                  <button onClick={handlePrevPage} disabled={currentPage === 1}
                    style={{ border: "1px solid #1e6b72", padding: "4px 10px", borderRadius: 5, cursor: "pointer", background: "#0c2e32", color: "#89a8c0", fontSize: "12px" }}>
                    ‹ Prev
                  </button>
                  {paginationNumbers.map((num) => (
                    <button key={num} onClick={() => handlePageChange(num)}
                      style={{ fontWeight: num === currentPage ? "bold" : "normal", background: num === currentPage ? "#1e6b72" : "#0c2e32", color: num === currentPage ? "#fff" : "#89a8c0", border: "1px solid #1e6b72", padding: "4px 10px", borderRadius: 5, cursor: "pointer", fontSize: "12px" }}>
                      {num}
                    </button>
                  ))}
                  <button onClick={handleNextPage} disabled={currentPage === totalPages}
                    style={{ border: "1px solid #1e6b72", padding: "4px 10px", borderRadius: 5, cursor: "pointer", background: "#0c2e32", color: "#89a8c0", fontSize: "12px" }}>
                    Next ›
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ── Device Comments modal — same threaded UI as patient-list ── */}
      <Modal
        isOpen={showCommentsModal}
        onRequestClose={() => { setShowCommentsModal(false); setNewComment(""); }}
        contentLabel="Device Comments"
        style={{
          overlay: { background: "rgba(0,0,0,0.5)", zIndex: 1050 },
          content: {
            padding: 0, border: "none", borderRadius: 10, overflow: "hidden",
            boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
            width: "94%", maxWidth: 860,
            top: "50%", left: "50%", right: "auto", bottom: "auto",
            transform: "translate(-50%, -50%)", marginRight: "-50%", background: "#fff",
          },
        }}
      >
        {/* Header */}
        <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
              💬 Device Comments
            </div>
            {commentsDevice && (
              <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                {commentsDevice.serial_no || "—"}
                <span style={{ color: "#5a8fa8", marginLeft: 6, fontSize: "11px" }}>
                  {commentsDevice.mac_id || commentsDevice.Mac_id || ""}
                </span>
              </div>
            )}
          </div>
          <button type="button"
            onClick={() => { setShowCommentsModal(false); setNewComment(""); }}
            style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
            ×
          </button>
        </div>

        {/* History */}
        {loadingComments ? (
          <div style={{ padding: "30px 16px", textAlign: "center", color: "#666", fontSize: "13px", background: "#f5f7fa" }}>Loading…</div>
        ) : (() => {
          const raw = (commentsText || "").trim();
          const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
          return (
            <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
              {lines.length === 0 ? (
                <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
              ) : (
                lines.map((line, idx) => {
                  const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                              || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                  const text = byMatch ? byMatch[1].trim() : line;
                  const author = byMatch ? byMatch[2].trim() : "";
                  const time = byMatch ? byMatch[3] || "" : "";
                  const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() : "?";
                  const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                  const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                  return (
                    <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                        {initials}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                          {text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}
                        </div>
                        <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                          <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                          {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          );
        })()}

        {/* New comment */}
        <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
          <textarea
            value={newComment}
            onChange={e => setNewComment(e.target.value)}
            placeholder="Type your observation, finding or note here…"
            maxLength={300}
            rows={3}
            style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
            onFocus={e => e.target.style.borderColor = "#4299e1"}
            onBlur={e => e.target.style.borderColor = "#cbd5e0"}
          />
          <div style={{ textAlign: "right", fontSize: "11px", color: newComment.length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
            {newComment.length}/300
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
          <button type="button"
            onClick={() => { setShowCommentsModal(false); setNewComment(""); }}
            style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
            Cancel
          </button>
          <button type="button"
            onClick={saveComment}
            disabled={savingComments || loadingComments || !newComment.trim()}
            style={{
              padding: "7px 22px", fontSize: "13px",
              background: newComment.trim() ? "#1e8449" : "#a8d5b5",
              border: "none", borderRadius: 6, color: "#fff", fontWeight: 700,
              cursor: newComment.trim() ? "pointer" : "not-allowed",
              transition: "background 0.2s",
            }}>
            ✓ Add Comment
          </button>
        </div>
      </Modal>

      {/* Edit Device Modal */}
      {selectedDevice && (
        <div id="editDeviceModal" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog" style={{ maxWidth: 580, margin: "40px auto", width: "94%" }}>
            <div className="modal-content" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
              <div style={{
                borderRadius: 16, overflow: "hidden",
                background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
                boxShadow: "0 32px 80px rgba(0,0,0,0.65), 0 0 0 1px rgba(46,170,187,0.2)",
              }}>

                {/* ── Header ── */}
                <div style={{
                  background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
                  padding: "18px 24px",
                  borderBottom: "1px solid rgba(46,170,187,0.18)",
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{
                      width: 38, height: 38, borderRadius: 10,
                      background: "linear-gradient(135deg,rgba(46,170,187,0.3),rgba(46,170,187,0.08))",
                      border: "1px solid rgba(46,170,187,0.4)",
                      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                    }}>
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#2eaabb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: "15px" }}>Edit Device Details</div>
                      <div style={{ color: "#4a8a9a", fontSize: "11px", marginTop: 2 }}>Update device information</div>
                    </div>
                  </div>
                  <button type="button" className="close" data-dismiss="modal"
                    style={{
                      background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
                      color: "#7fb8c8", width: 32, height: 32, borderRadius: "50%",
                      fontSize: "20px", cursor: "pointer", display: "flex",
                      alignItems: "center", justifyContent: "center",
                      opacity: 1, lineHeight: 1, padding: 0, float: "none",
                    }}
                  >&times;</button>
                </div>

                {/* ── Body ── */}
                <div style={{ padding: "22px 24px 16px" }}>
                  {/* Teal accent bar */}
                  <div style={{ height: 3, borderRadius: 2, background: "linear-gradient(90deg,#2eaabb,transparent)", marginBottom: 20 }} />

                  {/* Field helper */}
                  {(() => {
                    const field = (label, icon, content) => (
                      <div style={{ marginBottom: 16 }}>
                        <label style={{
                          display: "flex", alignItems: "center", gap: 6,
                          color: "#7fb8c8", fontSize: "11px", fontWeight: 700,
                          textTransform: "uppercase", letterSpacing: "0.7px", marginBottom: 6,
                        }}>
                          <span style={{ fontSize: "13px", opacity: 0.8 }}>{icon}</span>{label}
                        </label>
                        {content}
                      </div>
                    );
                    const inp = (name, value, disabled) => (
                      <input
                        type="text"
                        name={name}
                        value={value}
                        disabled={!!disabled}
                        onChange={handleInputChange}
                        style={{
                          width: "100%", padding: "10px 13px",
                          background: disabled ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.05)",
                          border: `1px solid ${disabled ? "rgba(46,170,187,0.12)" : "rgba(46,170,187,0.28)"}`,
                          borderRadius: 8, color: disabled ? "#4a7a88" : "#ddeef2",
                          fontSize: "13.5px", outline: "none", boxSizing: "border-box",
                          cursor: disabled ? "not-allowed" : "text",
                        }}
                      />
                    );
                    return (
                      <>
                        {/* Row 1 */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
                          {field("Version Details", "🔖", inp("VerisonDetails", selectedDevice.VerisonDetails || ""))}
                          {field("Serial No", "🔢", inp("serial_no", selectedDevice.serial_no || ""))}
                        </div>
                        {/* Row 2 */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
                          {field("WhatsApp Number", "💬", inp("whatsapp", selectedDevice.whatsapp || ""))}
                          {field("Mail", "✉️", inp("mail", selectedDevice.mail || ""))}
                        </div>
                        {/* Row 3 */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
                          {field("Customer Details", "🏢", inp("customer_details", selectedDevice.customer_details || ""))}
                          {field("Account Coordinator", "👤", inp("contactPerson", selectedDevice.contactPerson || ""))}
                        </div>
                        {/* Row 4 */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
                          {field("MAC ID", "📡", inp("mac_id", selectedDevice.mac_id || "", true))}
                          {field("Customer ID", "🏷️",
                            <select
                              name="customerId"
                              value={selectedDevice.customerId || ""}
                              onChange={(e) => {
                                const selectedId = e.target.value;
                                const selected = customerNames.find((c) => c.id === selectedId);
                                // Auto-fill contact fields from the customer so
                                // device-details stays in sync with Users-by-role.
                                // Admin can still override per-device after.
                                setSelectedDevice((prev) => ({
                                  ...prev,
                                  customerId:       selectedId,
                                  customerName:     selected ? selected.name : "",
                                  customer_details: selected ? selected.name : prev.customer_details,
                                  contactPerson:    (selected && selected.contactPerson) || prev.contactPerson,
                                  whatsapp:         (selected && selected.whatsapp)      || prev.whatsapp,
                                  mail:             (selected && selected.mail)          || prev.mail,
                                }));
                              }}
                              style={{
                                width: "100%", padding: "10px 13px",
                                background: "rgba(255,255,255,0.05)",
                                border: "1px solid rgba(46,170,187,0.28)",
                                borderRadius: 8, color: "#ddeef2",
                                fontSize: "13.5px", outline: "none", boxSizing: "border-box",
                              }}
                            >
                              <option value="" style={{ background: "#0e2a2e" }}>Select Customer</option>
                              {customerNames && customerNames.length > 0
                                ? [...customerNames]
                                    // Sort: rows with a WCN id first (asc), then unassigned (alpha by name)
                                    .sort((a, b) => {
                                      const aw = /^WCN/i.test(a.id || "");
                                      const bw = /^WCN/i.test(b.id || "");
                                      if (aw !== bw) return aw ? -1 : 1;
                                      if (aw) return String(a.id).localeCompare(String(b.id));
                                      return String(a.name || "").localeCompare(String(b.name || ""));
                                    })
                                    .map((c) => {
                                      const isWcn = /^WCN/i.test(c.id || "");
                                      const label = isWcn
                                        ? `${c.id} · ${c.name}`            // "WCN001 · Daya"
                                        : `(no WCN) ${c.name || c.id}`;    // unassigned customers
                                      return (
                                        <option key={c.id} value={c.id} style={{ background: "#0e2a2e" }}>
                                          {label}
                                        </option>
                                      );
                                    })
                                : <option disabled style={{ background: "#0e2a2e" }}>Loading...</option>
                              }
                            </select>
                          )}
                        </div>
                      </>
                    );
                  })()}
                </div>

                {/* ── Footer ── */}
                <div style={{
                  padding: "16px 24px 22px",
                  borderTop: "1px solid rgba(46,170,187,0.12)",
                  display: "flex", justifyContent: "flex-end", gap: 10,
                }}>
                  <button type="button" data-dismiss="modal"
                    style={{
                      padding: "9px 22px", fontSize: "13px", fontWeight: 600,
                      background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)",
                      borderRadius: 9, color: "#89a8c0", cursor: "pointer",
                    }}
                  >Cancel</button>
                  <button type="button" onClick={handleEditDevice}
                    style={{
                      padding: "9px 26px", fontSize: "13px", fontWeight: 700,
                      background: "linear-gradient(135deg,#2eaabb,#1a8a9a)",
                      border: "none", borderRadius: 9, color: "#fff",
                      cursor: "pointer", boxShadow: "0 4px 18px rgba(46,170,187,0.4)",
                      display: "flex", alignItems: "center", gap: 7,
                    }}
                  >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    Save Changes
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
      {/* ── Add Device Modal — modern dark UI ── */}
      <div id="addDeviceModal" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-lg" style={{ maxWidth: 660, margin: "30px auto", width: "94%" }}>
          <div className="modal-content" style={{
            background: "transparent", border: "none", boxShadow: "none",
          }}>
            <div style={{
              borderRadius: 14, overflow: "hidden",
              background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
              boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(46,170,187,0.18)",
            }}>
              {/* Header */}
              <div style={{
                background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
                padding: "16px 22px",
                borderBottom: "1px solid rgba(46,170,187,0.18)",
                display: "flex", alignItems: "center", justifyContent: "space-between",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10,
                    background: "linear-gradient(135deg,rgba(46,170,187,0.3),rgba(46,170,187,0.08))",
                    border: "1px solid rgba(46,170,187,0.4)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 18,
                  }}>📡</div>
                  <div>
                    <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: 15 }}>Add Device</div>
                    <div style={{ color: "#4a8a9a", fontSize: 11, marginTop: 2 }}>Register a new device to inventory</div>
                  </div>
                </div>
                <button type="button" data-dismiss="modal"
                  style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: "#9ab3bd", width: 30, height: 30, borderRadius: 8, fontSize: 16, lineHeight: 1, cursor: "pointer", padding: 0 }}>×</button>
              </div>

              {/* Body */}
              <div style={{ padding: "18px 22px", background: "#0a1f22" }}>
                {(() => {
                  const labelStyle = { color: "#89a8c0", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 5, display: "block" };
                  const inputStyle = {
                    width: "100%", height: 36, padding: "0 12px",
                    background: "#0f3538", border: "1px solid rgba(46,170,187,0.3)",
                    borderRadius: 6, color: "#e2eef2", fontSize: 13, outline: "none",
                  };
                  const fieldGap = { marginBottom: 12 };
                  return (
                    <>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>MAC ID</label>
                          <input type="text" name="mac_id" value={newDevice.mac_id} onChange={handleNewDeviceChange} style={inputStyle} placeholder="AA:BB:CC:DD:EE:FF" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>Serial No</label>
                          <input type="text" name="serial_no" value={newDevice.serial_no} onChange={handleNewDeviceChange} style={inputStyle} placeholder="BCZxxxxxxxxx" />
                        </div>
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>📱 WhatsApp Number</label>
                          <input type="text" name="whatsapp" value={newDevice.whatsapp} onChange={handleNewDeviceChange} style={inputStyle} placeholder="9999999999" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>✉️ Email</label>
                          <input type="email" name="mail" value={newDevice.mail} onChange={handleNewDeviceChange} style={inputStyle} placeholder="contact@company.com" />
                        </div>
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>🏢 Customer Details</label>
                          <input type="text" name="customer_details" value={newDevice.customer_details} onChange={handleNewDeviceChange} style={inputStyle} placeholder="Customer / clinic name" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>👤 Account Coordinator</label>
                          <input type="text" name="contactPerson" value={newDevice.contactPerson} onChange={handleNewDeviceChange} style={inputStyle} placeholder="Coordinator name" />
                        </div>
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>Version</label>
                          <input type="text" name="VerisonDetails" value={newDevice.VerisonDetails || ""} onChange={handleNewDeviceChange} style={inputStyle} placeholder="V1.5" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>🆔 Linked Customer</label>
                          <select
                            name="customerId"
                            value={newDevice.customerId || ""}
                            onChange={(e) => {
                              handleCustomerSelect(e);
                              setCustomerSearch("");
                            }}
                            style={{ ...inputStyle, padding: "0 8px", appearance: "auto" }}
                          >
                            <option value="">Select customer…</option>
                            {[...customerNames]
                              .sort((a, b) => {
                                const aw = /^WCN/i.test(a.id || "");
                                const bw = /^WCN/i.test(b.id || "");
                                if (aw !== bw) return aw ? -1 : 1;
                                if (aw) return String(a.id).localeCompare(String(b.id));
                                return String(a.name || "").localeCompare(String(b.name || ""));
                              })
                              .map((customer) => {
                                const isWcn = /^WCN/i.test(customer.id || "");
                                const label = isWcn
                                  ? `${customer.id} · ${customer.name}`
                                  : `(no WCN) ${customer.name || customer.id}`;
                                return (
                                  <option key={customer.id} value={customer.id}>{label}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>

              {/* Footer */}
              <div style={{
                padding: "12px 22px",
                background: "#0c2e32",
                borderTop: "1px solid rgba(46,170,187,0.18)",
                display: "flex", justifyContent: "flex-end", gap: 8,
              }}>
                <button type="button" data-dismiss="modal"
                  style={{ padding: "7px 18px", fontSize: 13, background: "transparent", border: "1px solid rgba(154,179,189,0.4)", borderRadius: 6, color: "#9ab3bd", cursor: "pointer", fontWeight: 500 }}>
                  Cancel
                </button>
                <button type="button" onClick={handleAddDevice}
                  style={{ padding: "7px 22px", fontSize: 13, background: "linear-gradient(90deg,#1e8449,#27ae60)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontWeight: 700 }}>
                  ➕ Add Device
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add Customer Modal — modern dark UI ── */}
      <div id="addCustomerModal" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-lg" style={{ maxWidth: 660, margin: "30px auto", width: "94%" }}>
          <div className="modal-content" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
            <div style={{
              borderRadius: 14, overflow: "hidden",
              background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
              boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(46,205,153,0.18)",
            }}>
              {/* Header */}
              <div style={{
                background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
                padding: "16px 22px",
                borderBottom: "1px solid rgba(46,205,153,0.18)",
                display: "flex", alignItems: "center", justifyContent: "space-between",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10,
                    background: "linear-gradient(135deg,rgba(46,205,153,0.3),rgba(46,205,153,0.08))",
                    border: "1px solid rgba(46,205,153,0.4)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 18,
                  }}>🏢</div>
                  <div>
                    <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: 15 }}>Add Customer</div>
                    <div style={{ color: "#4a8a9a", fontSize: 11, marginTop: 2 }}>Register a new customer / doctor / hospital</div>
                  </div>
                </div>
                <button type="button" data-dismiss="modal"
                  style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: "#9ab3bd", width: 30, height: 30, borderRadius: 8, fontSize: 16, lineHeight: 1, cursor: "pointer", padding: 0 }}>×</button>
              </div>

              {/* Body */}
              <div style={{ padding: "18px 22px", background: "#0a1f22" }}>
                {(() => {
                  const labelStyle = { color: "#89a8c0", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 5, display: "block" };
                  const inputStyle = {
                    width: "100%", height: 36, padding: "0 12px",
                    background: "#0f3538", border: "1px solid rgba(46,205,153,0.3)",
                    borderRadius: 6, color: "#e2eef2", fontSize: 13, outline: "none",
                  };
                  const fieldGap = { marginBottom: 12 };
                  return (
                    <>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>👤 Name</label>
                          <input type="text" name="name" value={newCustomer.name} onChange={handleNewCustomerChange} style={inputStyle} placeholder="Full name" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>📱 Phone</label>
                          <input type="text" name="phone" value={newCustomer.phone} onChange={handleNewCustomerChange} style={inputStyle} placeholder="9999999999" />
                        </div>
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>✉️ Email</label>
                          <input type="email" name="email" value={newCustomer.email} onChange={handleNewCustomerChange} autoComplete="off" style={inputStyle} placeholder="email@example.com" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>🔑 Password</label>
                          <input type="password" name="password" value={newCustomer.password} onChange={handleNewCustomerChange} autoComplete="new-password" style={inputStyle} placeholder="••••••••" />
                        </div>
                      </div>

                      <div style={fieldGap}>
                        <label style={labelStyle}>🏠 Address</label>
                        <input type="text" name="address" value={newCustomer.address} onChange={handleNewCustomerChange} style={inputStyle} placeholder="City, State" />
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>🏷️ Customer name</label>
                          <input type="text" name="customerName" value={newCustomer.customerName} onChange={handleNewCustomerChange} style={inputStyle} placeholder="Long-form / legal name" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>⚧ Gender</label>
                          <select name="gender" value={newCustomer.gender} onChange={handleNewCustomerChange} style={inputStyle}>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <option value="O">Other</option>
                          </select>
                        </div>
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div style={fieldGap}>
                          <label style={labelStyle}>🤝 Account coordinator</label>
                          <input type="text" name="contactPerson" value={newCustomer.contactPerson} onChange={handleNewCustomerChange} style={inputStyle} placeholder="Person who liaises with us" />
                        </div>
                        <div style={fieldGap}>
                          <label style={labelStyle}>💬 WhatsApp number</label>
                          <input type="text" name="whatsappNumber" value={newCustomer.whatsappNumber} onChange={handleNewCustomerChange} style={inputStyle} placeholder="10-digit number" maxLength={10} />
                        </div>
                      </div>

                      <div style={fieldGap}>
                        <label style={labelStyle}>📧 Contact email</label>
                        <input type="email" name="mailContact" value={newCustomer.mailContact} onChange={handleNewCustomerChange} style={inputStyle} placeholder="contact@example.com" />
                      </div>

                      <div style={fieldGap}>
                        <label style={labelStyle}>Type</label>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          {[
                            { v: "customer", label: "🏢 Customer", color: "#2eaabb", rgb: "46,170,187"  },
                            { v: "doctor",   label: "🩺 Doctor",   color: "#3498db", rgb: "52,152,219"  },
                            { v: "hospital", label: "🏥 Hospital", color: "#9b59b6", rgb: "155,89,182"  },
                          ].map((t) => {
                            const active = newCustomer.type === t.v;
                            return (
                              <button key={t.v} type="button"
                                onClick={() => handleNewCustomerChange({ target: { name: "type", value: t.v } })}
                                style={{
                                  flex: "1 1 auto", minWidth: 110,
                                  padding: "8px 10px", fontSize: 12, fontWeight: 600,
                                  background: active ? `rgba(${t.rgb},0.18)` : "transparent",
                                  border: `1px solid ${active ? t.color : "rgba(154,179,189,0.25)"}`,
                                  color: active ? t.color : "#9ab3bd",
                                  borderRadius: 6, cursor: "pointer",
                                  transition: "all 0.15s",
                                }}
                              >{t.label}</button>
                            );
                          })}
                        </div>
                      </div>

                      {newCustomer.type === "customer" && (
                        <div style={fieldGap}>
                          <label style={labelStyle}>📂 Account category</label>
                          <select name="accountCategory" value={newCustomer.accountCategory} onChange={handleNewCustomerChange} style={inputStyle}>
                            <option value="partner">Partner</option>
                            <option value="hospital">Hospital</option>
                            <option value="distributor">Distributor</option>
                          </select>
                        </div>
                      )}
                      {newCustomer.type === "doctor" && (
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                          <div style={fieldGap}>
                            <label style={labelStyle}>✍️ Signing handle</label>
                            <input type="text" name="signatureDoctorId" value={newCustomer.signatureDoctorId} onChange={handleNewCustomerChange} style={inputStyle} placeholder="e.g. prajjal" />
                          </div>
                          <div style={fieldGap}>
                            <label style={labelStyle}>🔗 Linked DB ID</label>
                            <input type="text" name="database_id" value={newCustomer.database_id} onChange={handleNewCustomerChange} style={inputStyle} placeholder="ObjectId of the linked doctor record" />
                          </div>
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>

              {/* Footer */}
              <div style={{
                padding: "12px 22px",
                background: "#0c2e32",
                borderTop: "1px solid rgba(46,205,153,0.18)",
                display: "flex", justifyContent: "flex-end", gap: 8,
              }}>
                <button type="button" data-dismiss="modal"
                  style={{ padding: "7px 18px", fontSize: 13, background: "transparent", border: "1px solid rgba(154,179,189,0.4)", borderRadius: 6, color: "#9ab3bd", cursor: "pointer", fontWeight: 500 }}>
                  Cancel
                </button>
                <button type="button" onClick={handleAddCustomer}
                  style={{ padding: "7px 22px", fontSize: 13, background: "linear-gradient(90deg,#1e8449,#27ae60)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontWeight: 700 }}>
                  ➕ Add Customer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class MacIdModal extends Component {
  state = {
    showModal: false,
    macIdData: null,
  };
   
  macIdClicked = (e) => {
    const mac_id = e.currentTarget.id;

    axios
      .get(`${apiUrl}api/users/getSubsribe`, { params: { mac_id } })
      .then((res) => {
        this.setState({ macIdData: res.data.data, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Error fetching MAC ID details");
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { device } = this.props;
    const { showModal, macIdData } = this.state;

    return (
      <>
        <button
          type="button"
          className="macid_button"
          id={device.mac_id}
          onClick={this.macIdClicked}
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            textDecoration: "underline",
            padding: 0,
          }}
        >
          {device.mac_id || "_"}
        </button>

        {macIdData && (
          <Modal
            isOpen={showModal}
            onRequestClose={this.handleCloseModal}
            contentLabel="Previous Patient Records"
            style={{
              content: {
                color: "black",
                width: "60%",
                margin: "auto",
                marginTop: "6%",
              },
            }}
          >
            <h2 style={{ color: "black" }}>MAC ID Records</h2>

            <p style={{ color: "black", fontSize: "15px" }}>
              {macIdData
                .replace(/{"response":200}/g, "") // Remove {"response":200} from the string
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                    <br />
                  </span>
                ))}
            </p>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleCloseModal}
              style={{ marginTop: "20px" }}
            >
              Close
            </button>
          </Modal>
        )}
      </>
    );
  }
}

export default DeviceDetails;
